import { observer } from 'mobx-react-lite'
import { useFeatures } from '@/contexts/root-store-context'
import { type OpportunityDetailsViewModel } from '@/features/opportunities/OpportunityDetailsViewModel'
import {
  OpportunityDetailsBody,
  OpportunityDetailsPickupActions,
  OpportunityDetailsSheet,
} from '@/features/opportunities/components/OpportunityDetailsSheet'

export interface OpportunityDetailsSheetContainerProps {
  vm: OpportunityDetailsViewModel
  onClose?: () => void
}

export const OpportunityDetailsSheetContainer = observer(
  function OpportunityDetailsSheetContainer({
    vm,
    onClose,
  }: OpportunityDetailsSheetContainerProps) {
    const { shellInfo } = useFeatures(({ shell }) => ({
      shellInfo: shell.shellInfo,
    }))
    const selected = vm.selected
    if (!selected) {
      return (
        <OpportunityDetailsSheet
          header={null}
          onClose={onClose}
          corporateMode={shellInfo.corporateMode}
        />
      )
    }

    return (
      <OpportunityDetailsSheet
        onClose={onClose}
        corporateMode={shellInfo.corporateMode}
        header={selected.header}
        actions={
          <OpportunityDetailsPickupActions
            showPickup={selected.canPickUpAsMyself}
            isPickupPending={vm.pickup.pending}
            onPickup={vm.pickup}
            showApply={vm.canShowApplyButton}
            applied={vm.applied}
            isApplyPending={vm.isApplyPending}
            onApply={vm.applyForOpportunity}
            onWithdraw={vm.withdrawOpportunityApplication}
            timeUntilSelection={selected.selectionCountdown}
          />
        }
      >
        <OpportunityDetailsBody
          infoLines={selected.infoLines}
          providerCutAmount={selected.providerCutAmount}
          deadline={selected.deadline}
          scopeItems={selected.bookkeepingScopeItems}
        />
      </OpportunityDetailsSheet>
    )
  },
)
